module.exports = __webpack_public_path__ + "img/download-bg.e6cad7dd.png";